import { en } from './en';
import { zhCN } from './zh-CN';
import { si } from './si';
import { Language } from '@/contexts/LanguageContext';

export const translations = {
  en,
  'zh-CN': zhCN,
  si
};

export const useTranslations = (language: Language) => {
  return translations[language];
};